import React, { Fragment } from "react";
import { List, Datagrid, Edit, Create, SimpleForm, TextField, SearchInput, EditButton, TextInput, BooleanField, TranslatableFields, BooleanInput, CreateButton, TopToolbar, PasswordInput, email, minLength } from 'react-admin';
import PersonIcon from '@material-ui/icons/Person';
import OrderingField from '../Fields/Ordering.field';
import { Route, useHistory } from 'react-router';
import { Drawer, makeStyles } from '@material-ui/core';
import { required } from 'react-admin';
import { translations } from '../../i18n/i18n';
import ConfigGeneral from '../../config/general';

const useStyles = makeStyles({
	drawerContent: {
		width: 500
	}
});

const filters = [
    <SearchInput source="name" alwaysOn />,
];

const ListActions = ({ basePath }) => (
	<TopToolbar>
		<CreateButton basePath={basePath} />
	</TopToolbar>
);

const UserIcon = PersonIcon;
const UserList = (props) => {
	const classes = useStyles();
	const history = useHistory();
	const handleClose = () => history.push('/'+props.resource);

	return <Fragment>
		<List actions={<ListActions />} filters={filters} perPage={25} sort={{ field: 'id', order: 'ASC' }} {...props}>
			<Datagrid>
				<TextField source="id" />
				<TextField source="name" />
				<TextField source="email" />
				<EditButton basePath="/users" />
			</Datagrid>
		</List>

		<Route path={'/'+props.resource+'/create'} exact>
			{({ match }) => (
				<Drawer open={!!match} anchor="right" onClose={handleClose}>
					<UserCreate className={classes.drawerContent} onCancel={handleClose} {...props} />
				</Drawer>
			)}
		</Route>

		<Route path={'/'+props.resource+'/:id'}>
			{({ match }) => {
				const isMatch = (match && match.params && match.params.id !== 'create');

				return (
					<Drawer open={!!isMatch} anchor="right" onClose={handleClose}>
						{isMatch ? (
							<UserEdit
								className={classes.drawerContent}
								id={isMatch ? match.params.id : null}
								onCancel={handleClose}
								{...props}
							/>
						) : (
							<div className={classes.drawerContent} />
						)}
					</Drawer>
				);
			}}
		</Route>
	</Fragment>
};

const UserEdit = (props) => (
    <Edit title=" " undoable={false} {...props}>
        <SimpleForm>
			<TextInput source="name" fullWidth validate={[required()]} />
			<TextInput source="email" fullWidth validate={[required(), email()]} />
			<PasswordInput source="password" fullWidth validate={[minLength(5)]} />
        </SimpleForm>
    </Edit>
);

const UserCreate = (props) => (
    <Create title=" " undoable={false} {...props}>
        <SimpleForm>
			<TextInput source="name" fullWidth validate={[required()]} />
			<TextInput source="email" fullWidth validate={[required(), email()]} />
			<PasswordInput source="password" fullWidth validate={[required(), minLength(5)]} />
        </SimpleForm>
    </Create>
);

let exports = {
	list: UserList,
	icon: UserIcon,
};
export default exports;